import FeaturedCaseStudies from "@client/components/FeaturedCaseStudies";
import { FullWidthMedia } from "@client/components/FullWidthMedia";
import { MediaFeedBlock } from "@client/components/MediaFeedBlock";
import { PageSkeleton } from "@client/components/PageSkeleton";
import ServicesModules from "@client/components/ServicesModule";
import ShowcaseBlock from "@client/components/ShowcaseBlock";
import ThreejsEmbed from "@client/components/ThreejsEmbed";
import Ticker from "@client/components/homepage/Ticker";
import { ScrollTrigger, gsap } from "@client/gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import React from "react";

import {
    AnimatedFeaturedRichTextBlock,
    LogoListBlock,
    templates,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import ExpandMediaBlock from "../components/ExpandMediaBlock";
import { FeaturedRichTextBlock } from "../components/RichText";
import { SpacerBlock } from "../components/SpacerBlock";
import { Svg } from "../components/Svg";
import { Home2026ExpertiseBlock } from "../components/design2026/home/Expertise";
import { Home2026FeaturedWorkBlock } from "../components/design2026/home/FeaturedWork";
import { Home2026HeroBlock } from "../components/design2026/home/Hero";
import { Home2026ProofBlock } from "../components/design2026/home/Proof";
import Hero from "../components/homepage/Hero";
import ParagraphSlides from "../components/homepage/ParagraphSlides";

import styles from "../components/homepage/homepage.module.scss";

gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);

function LogoList(props: LogoListBlock) {
    return (
        <div className={styles.logoList}>
            {props.logos?.map(
                (logo, i) => logo.value && <Svg key={i} name={logo.value} />,
            )}
        </div>
    );
}

function FeaturedRichTextWrapper(props: AnimatedFeaturedRichTextBlock) {
    return (
        <div className={styles.rtf}>
            <FeaturedRichTextBlock {...props} />
        </div>
    );
}

export const Template = (props: templates.HomePageTemplate) => {
    const logoFadeInRef = React.useRef<HTMLDivElement>(null);
    return (
        <React.StrictMode>
            <PageSkeleton {...props.page} fixedLogoFadeInRef={logoFadeInRef}>
                <StreamField
                    tagName={React.Fragment}
                    value={props.page.body.value}
                    components={{
                        hero: (block) => <Hero {...block.value} />,
                        hero_image: (block) => <FullWidthMedia {...block} />,
                        expand_media: (block) => (
                            <ExpandMediaBlock {...block.value} />
                        ),
                        paragraph_slides: (block) => (
                            <ParagraphSlides {...block.value} />
                        ),
                        ticker: (block) => <Ticker {...block.value} />,
                        blog_showcase: (block) => (
                            <>
                                <FeaturedCaseStudies {...block.value} />
                                <div ref={logoFadeInRef} />
                            </>
                        ),
                        logo_list: (block) => <LogoList {...block.value} />,
                        showcase: (block) => <ShowcaseBlock {...block.value} />,
                        rich_text: (block) => (
                            <FeaturedRichTextWrapper {...block.value} />
                        ),
                        spacer: (block) => <SpacerBlock value={block.value} />,
                        media_feed: (block) => (
                            <MediaFeedBlock {...block.value} />
                        ),
                        three_d_embed: (block) => (
                            <ThreejsEmbed {...block.value} />
                        ),
                        services: ServicesModules,
                        home_2026_hero: (block) => (
                            <Home2026HeroBlock {...block.value} />
                        ),
                        home_2026_featured_work: (block) => (
                            <Home2026FeaturedWorkBlock {...block.value} />
                        ),
                        home_2026_expertise: (block) => (
                            <Home2026ExpertiseBlock {...block.value} />
                        ),
                        home_2026_proof: (block) => (
                            <Home2026ProofBlock {...block.value} />
                        ),
                    }}
                />
            </PageSkeleton>
        </React.StrictMode>
    );
};
